module.exports = __webpack_public_path__ + "static/media/brewer-stage-logo.d1e27449.png";